
import { Component, Mixins } from "vue-property-decorator";
import InfiniteLoading from "vue-infinite-loading";

@Component
export default class ForceUseInfiniteWrapperForInfiniteLoadingMixin extends Mixins() {
  data(): any {
    return {
      forceUseInfiniteWrapper: false,
    };
  }
  forceUseInfiniteWrapper: boolean | string;

  updateForceUseInfiniteWrapper(element: HTMLElement, infiniteLoading: InfiniteLoading): void {
    this.forceUseInfiniteWrapper = (this.toDatasetString(element) + " .el-table__body-wrapper").trim();
    // vue-infinite-loading v2.4.3ではforceUseInfiniteWrapperを変更した場合、正しくイベントが上がらなくなってしまう。reset()を行うことで対応。
    // TODO: v2.4.4では発生しないためバージョンアップ時に削除する
    this.$nextTick(() => {
      infiniteLoading.stateChanger.reset();
    });
  }

  private toDatasetString(element: HTMLElement): string {
    return Object.keys(element.dataset)
      .map(k => "[data-" + this.toKebabCase(k) + "]")
      .join("");
  }

  private toKebabCase(str: string): string {
    return str
      .replace(/^ *?[A-Z]/, s => s.toLowerCase())
      .replace(/_/g, "-")
      .replace(/ *?[A-Z]/g, s => "-" + s.replace(/ /g, "").toLowerCase());
  }
}
